<template>
  <sc-table :data="tabResume"
            class="tab-resume">
    <template slot-scope="props">

      <sc-table-column field="description"
                       label="Motivo"
                       :centered="false"
                       :sortable="false">
        <span :class="{ 'tab-resume__column-child': props.row.isChild }">
          {{ props.row.description }}
        </span>
      </sc-table-column>

      <sc-table-column field="total_values.total_item_quantity"
                       label="CT-e">
        {{ props.row.total_values.total_item_quantity }}
      </sc-table-column>

      <sc-table-column field="total_values.total_invoice_cost"
                       label="Valor da fatura"
                       class="has-text-right">
        {{ props.row.total_values.total_invoice_cost | currency }}
      </sc-table-column>

      <sc-table-column field="total_values.total_cte_cost"
                       label="Valor CT-e"
                       class="has-text-right">
        {{ props.row.total_values.total_cte_cost | currency }}
      </sc-table-column>

      <sc-table-column field="total_values.total_quote_cost"
                       label="Valor esperado Intelipost"
                       class="has-text-right">
        {{ props.row.total_values.total_quote_cost | currency }}
      </sc-table-column>

      <sc-table-column field="total_values.total_divergence_cost"
                       label="Variação"
                       class="has-text-right">
        {{ props.row.total_values.total_divergence_cost | currency }}
      </sc-table-column>

    </template>

    <template slot="empty">
      <sc-table-empty />
    </template>

    <template slot="footer" v-if="tabResume.length > 0">
      <th>
        <div class="th-wrap has-text-left">
          Total geral
        </div>
      </th>
      <th class="has-text-centered">
        {{ invoice.total_values.total_item_quantity }}
      </th>
      <th class="has-text-right">
        {{ invoice.total_values.total_invoice_cost | currency }}
      </th>
      <th class="has-text-right">
        {{ invoice.total_values.total_cte_cost | currency }}
      </th>
      <th class="has-text-right">
        {{ invoice.total_values.total_quote_cost | currency }}
      </th>
      <th class="has-text-right">
        {{ invoice.total_values.total_divergence_cost | currency }}
      </th>
    </template>

  </sc-table>
</template>

<script>
  import {
    ScTable,
    ScTableColumn,
    ScTableEmpty,
  } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  const { mapState, mapGetters } = createNamespacedHelpers('recon/invoiceAudit');

  export default {
    name: 'tab-invoice-audit-detail-resume',
    computed: {
      ...mapState([
        'invoice',
      ]),
      ...mapGetters([
        'tabResume',
      ]),
    },
    components: {
      ScTable,
      ScTableColumn,
      ScTableEmpty,
    },
  };
</script>

<style lang="scss">
  .tab-resume__column-child{
    padding-left: 1rem;
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/invoice-audit/pages/invoice-audit-detail/components/tab-resume/TabInvoiceAuditDetailResume.vue